import __regexp from './__yandex-regexp';
import { matchVersion } from '../../utils';
/** Detect Yandex Browser */
export default function isYandexVersion(operator, version) {
	return function (ua) {
		return matchVersion({
			ua: ua,
			version: version,
			operator: operator,
			regExp: __regexp,
			groupIndex: 1
		});
	};
}
